<ng-container [ngSwitch]="status">
  <div *ngSwitchCase="'STARTED'"
       class="status status-started" [tooltip]="'WORKFLOWS.started' | translate | uppercase">
    <em class="fa-duotone fa-solid fa-spinner-third"></em>
  </div>
  <div *ngSwitchCase="'IN_PROGRESS'"
       class="status status-inProgress" [tooltip]="'WORKFLOWS.in_progress' | translate | uppercase">
    <em class="fa fa-light fa-duotone fa-solid fa-spinner-third"></em>
  </div>
  <div *ngSwitchCase="'VALIDATED'"
       class="status status-validated" [tooltip]="'WORKFLOWS.validated' | translate | uppercase">
    <em class="fa fa-light fa-check-circle"></em>
  </div>
  <div *ngSwitchCase="'REJECTED'"
       class="status status-rejected" [tooltip]="'WORKFLOWS.rejected' | translate | uppercase">
    <em class="fa fa-light fa-exclamation-circle"></em>
  </div>
  <div *ngSwitchCase="'ERROR'"
       class="status status-error" [tooltip]="'WORKFLOWS.error' | translate | uppercase">
    <em class="fa fa-light fa-exclamation-circle"></em>
  </div>
  <div *ngSwitchCase="'CANCELED'"
       class="status status-canceled" [tooltip]="'WORKFLOWS.canceled' | translate | uppercase">
    <em class="fa fa-light fa-ban"></em>
  </div>
  <div *ngSwitchCase="'ENDED'"
       class="status status-ended" [tooltip]="'WORKFLOWS.request_ended' | translate | uppercase">
    <em class="fa fa-light fa-circle"></em>
  </div>
</ng-container>
